import TokenOperador from './TokenOperador';
import TokenVariable from './TokenVariable';
import TokenNumero from './TokenNumero';
import NoVariableError from './NoVariableError';

export const OPERADORES = ['+', '-', '*', '/', '%', '(', ')'];

// Parseador de una fórmula en String para partirlo en un array de
// tokens que componen la fórmula
export default class Parser {
  constructor(variables) {
    this.variables = variables || [];
  }

  // Parsea la fórmula (competencia_1 + 4.2 - competencia_2) y
  // devuelve un array de objetos Token cada uno según su tipo
  parse(formula) {
    const regex = /([a-z0-9_.]*)\s*([+\-*/()%])?/gm;
    const tokens = [];

    Array.from(formula.matchAll(regex)).forEach((match) => {
      // grupo 1 es el de las variables y números (lo que no es operador)
      const variableNumero = match[1];
      const operador = match[2];
      if (variableNumero) {
        const numero = parseFloat(variableNumero);
        if (!Number.isNaN(numero)) {
          tokens.push(new TokenNumero(numero));
        } else {
          tokens.push(new TokenVariable(this.#getVariable(variableNumero)));
        }
      }
      if (operador) {
        tokens.push(new TokenOperador(operador));
      }
    });
    return tokens;
  }

  #getVariable(valor) {
    const variable = this.variables.find((v) => v.key === valor);

    if (!variable) {
      throw new NoVariableError(valor);
    }
    return variable;
  }
}
